module.exports = "<h4 id=\"基本用法\">基本用法</h4>\n";